export const PRACTICE_PROBLEM_BLURB = 'exam-style math and recall questions'
export const EXCEL_PRACTICE_PROBLEM_BLURB =
    'exam-style questions with Excel templates'
export const CUSTOM_PRACTICE_PROBLEM_BLURB =
    'custom-written math questions only available at JEP (not from previous exams)'
export const NOTECARD_BLURB = 'succinct notecards to master'
export const OUTLINE_BLURB = 'Comprehensive outlines of entire syllabus'
export const PREVIOUS_EXAM_PROBLEM_BLURB =
    'carefully selected problems from previous exams'
